import { EmployeeGroupBranchDetailsOutput } from './employee-group-branch-details-output.model';
import { EmployeeGroupWiseEmployeeOutput } from './employee-group-wise-employee-output.model';


export class EmployeeGroupOutput implements IEmployeeGroupOutput {
    /** The auto-generated id of the employee group master */
    employee_group_id!: number;
    /** The user group name with 255 character limit */
    employee_group_name!: string;
    /** The branch details type must be one of "All" or "Select" */
    branch_detail_type!: string;
    /** The description with 5000 character limit */
    description!: string;
    /** The auto-generated id of the employee master */
    company_details_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    employee_group_branch_details!: EmployeeGroupBranchDetailsOutput[];
    employee_list_of_employee_group!: EmployeeGroupWiseEmployeeOutput[];
    status!: number;

    constructor(data?: IEmployeeGroupOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee_group_id = _data["employee_group_id"];
            this.employee_group_name = _data["employee_group_name"];
            this.branch_detail_type = _data["branch_detail_type"];
            this.description = _data["description"];
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            if (Array.isArray(_data["employee_group_branch_details"])) {
                this.employee_group_branch_details = [] as any;
                for (let item of _data["employee_group_branch_details"])
                    this.employee_group_branch_details!.push(EmployeeGroupBranchDetailsOutput.fromJS(item));
            }
            if (Array.isArray(_data["employee_list_of_employee_group"])) {
                this.employee_list_of_employee_group = [] as any;
                for (let item of _data["employee_list_of_employee_group"])
                    this.employee_list_of_employee_group!.push(EmployeeGroupWiseEmployeeOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EmployeeGroupOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee_group_id"] = this.employee_group_id;
        data["employee_group_name"] = this.employee_group_name;
        data["branch_detail_type"] = this.branch_detail_type;
        data["description"] = this.description;
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        if (Array.isArray(this.employee_group_branch_details)) {
            data["employee_group_branch_details"] = [];
            for (let item of this.employee_group_branch_details)
                data["employee_group_branch_details"].push(item.toJSON());
        }
        if (Array.isArray(this.employee_list_of_employee_group)) {
            data["employee_list_of_employee_group"] = [];
            for (let item of this.employee_list_of_employee_group)
                data["employee_list_of_employee_group"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IEmployeeGroupOutput {
    /** The auto-generated id of the employee group master */
    employee_group_id: number;
    /** The user group name with 255 character limit */
    employee_group_name: string;
    /** The branch details type must be one of "All" or "Select" */
    branch_detail_type: string;
    /** The description with 5000 character limit */
    description: string;
    /** The auto-generated id of the employee master */
    company_details_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    employee_group_branch_details: EmployeeGroupBranchDetailsOutput[];
    employee_list_of_employee_group: EmployeeGroupWiseEmployeeOutput[];
    status: number;
}

